var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBannerSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4245 21.6844L6.42002 16.8136C5.86238 16.2709 4.97587 16.2709 4.41823 16.8136C3.86059 17.3564 3.86059 18.2192 4.41823 18.7619L10.4093 24.5929C10.9669 25.1357 11.8677 25.1357 12.4254 24.5929L27.5818 9.85537C28.1394 9.31262 28.1394 8.4498 27.5818 7.90706C27.0241 7.36431 26.1376 7.36431 25.58 7.90706L11.4245 21.6844Z",
    fill: "#2E7D32"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBannerSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/banner-success.d6eda427741a491cd4da2c817d34fd65.svg";